<script>
import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins
export default {
  extends: Line,
  mixins: [reactiveProp],
  name: 'AdjustableGraph',
  props: ['title'],
  mounted () {
    this.renderChart(this.chartData,
      {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          text: this.title
        },
        scales: {
          yAxes: [{
            ticks: {
              stepSize: 1,
              reverse: false,
              beginAtZero: true
            }
          }]
        }
      })
  }
}
</script>

<style scoped>

</style>
